import { render } from "./Select.vue?vue&type=template&id=475652f8&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&id=475652f8&scoped=true&lang=css"

import exportComponent from "/home/gustavo/Documents/frontend-ivv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475652f8"]])

export default __exports__